import { Observable, observe, Scope } from 'src/3rds/cube'

@Observable
export class RestrictedScope extends Scope {
    @observe() menu?: Scope | null
    @observe() detail?: Scope | null
}
